import { createJsonQuery } from '@farfetched/core'
import { runtypeContract } from '@farfetched/runtypes'
import { Array } from 'runtypes'
import { goodFeaturesUrl } from './api'
import { Features, IFeatures } from './contract'
import { combine } from 'effector/compat'

export interface IFeatureMap {
    [key: string]: string
}

export const goodsFeaturesTemplates = createJsonQuery({
    request: {
        method: 'GET',
        url: () => goodFeaturesUrl()
    },
    initialData: [] as IFeatures[],
    response: {
        contract: runtypeContract(Array(Features))
    }
})
export const $featuresMap = combine(goodsFeaturesTemplates.$data, (features) => {
    if (!features || features.length === 0) return null
    return Object.assign({}, ...features.map((feature) => ({ [feature.name]: feature.value }))) as IFeatureMap
})
